import { useWizard } from '@amzn/ring-ui-react-components';
import { PostingContext, PostingEvent } from '../postingMachine';

export const usePostingWizard = () => useWizard<PostingContext, PostingEvent>();
